import { motion } from "framer-motion";
import { CATEGORIES } from "../data/ideas";

const BLURBS = {
  mobilita:
    "Muoversi in città deve essere semplice, veloce e pulito. Meno traffico, più alternative reali per tutti.",
  ambiente:
    "Una Verona più verde e vivibile: aria pulita, energia rinnovabile e spazi naturali restituiti alle persone.",
  cultura:
    "La cultura come identità e motore. Dall'Arena alle biblioteche di quartiere, bellezza accessibile a tutti.",
  sicurezza:
    "Sicurezza vera fatta di presenza, prevenzione e cura degli spazi. Una città in cui sentirsi protetti.",
  lavoro:
    "Sostenere chi crea lavoro: negozi, artigiani e imprese. Meno burocrazia, più opportunità concrete.",
  sociale:
    "Nessuno da solo: servizi vicini alle famiglie, agli anziani e a chi è più fragile.",
  giovani:
    "Spazi, sport e ascolto per le nuove generazioni. Verona deve essere una città in cui i giovani restano.",
  digitale:
    "Un Comune moderno e trasparente, con servizi digitali semplici e dati aperti ai cittadini.",
};

export default function Manifesto({ ideas = [] }) {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="bg-[#0d2c54] text-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="mb-16 md:mb-24">
          <span className="flex items-center gap-3 mb-4">
            <span className="h-2 w-2 bg-[#d9381e]" />
            <span className="font-mono-num uppercase text-xs tracking-[0.25em] text-white/60">
              Otto Temi
            </span>
          </span>
          <h2 className="font-display font-black uppercase tracking-tighter text-5xl md:text-6xl lg:text-7xl leading-[0.85] max-w-3xl">
            Un manifesto in <span className="text-[#d9381e]">otto capitoli</span>
          </h2>
        </div>

        <div>
          {CATEGORIES.map((cat, i) => {
            const count = ideas.filter((x) => x.cat === cat.key).length;
            return (
              <motion.div
                key={cat.key}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`manifesto-chapter-${cat.key}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center py-10 md:py-14 border-t border-white/15"
              >
                <div className="md:col-span-1">
                  <span className="font-mono-num text-[#d9381e] text-xl md:text-2xl font-bold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="md:col-span-5">
                  <h3 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl leading-none">
                    {cat.short}
                  </h3>
                  <p className="mt-4 text-white/70 leading-relaxed max-w-md font-medium">
                    {BLURBS[cat.key]}
                  </p>
                  <span className="mt-5 inline-block font-mono-num uppercase text-[11px] tracking-widest text-white/50">
                    {String(count).padStart(2, "0")} proposte · {cat.label}
                  </span>
                </div>

                <div className="md:col-span-6">
                  <div className="relative overflow-hidden aspect-[16/9] md:aspect-[16/7]">
                    <img
                      src={cat.image}
                      alt={cat.label}
                      loading="lazy"
                      className="h-full w-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-700"
                    />
                    <div className="absolute inset-0 bg-[#0d2c54]/30 group-hover:bg-transparent transition-colors duration-500" />
                  </div>
                </div>
              </motion.div>
            );
          })}
          <div className="border-t border-white/15" />
        </div>
      </div>
    </section>
  );
}
